import preferences from 'Preferences';

import {HomepageCardDefaultLayouts} from '../HomepageCardDefinitions';
import {HomepagePreferences} from '../HomepageConstants';
import {
  HomepageCardLayoutDefinition,
  HomepageCardLayouts,
  sanitizeHomepageCardLayouts,
} from './HomepageCardLayout';

export function getSavedHomepageCardLayouts(
  cardLayoutDefinitions: ReadonlyArray<HomepageCardLayoutDefinition>,
  defaultLayouts: HomepageCardDefaultLayouts
): HomepageCardLayouts {
  return sanitizeHomepageCardLayouts(
    preferences.get(HomepagePreferences.HOMEPAGE_CARD_LAYOUT_V2),
    cardLayoutDefinitions,
    defaultLayouts
  );
}

export function saveHomepageCardLayouts(
  layouts: HomepageCardLayouts,
  cardLayoutDefinitions: ReadonlyArray<HomepageCardLayoutDefinition>,
  defaultLayouts: HomepageCardDefaultLayouts
): Promise<void> {
  return preferences.set(
    HomepagePreferences.HOMEPAGE_CARD_LAYOUT_V2,
    sanitizeHomepageCardLayouts(layouts, cardLayoutDefinitions, defaultLayouts)
  );
}
